module.exports = "<i class=\"fa fa-question-circle pointer\" ng-click=vm.openHelp()></i> ";


/*****************
 ** WEBPACK FOOTER
 ** ./src/app/app/components/cn-help-text/cn-help-text.html
 ** module id = 129
 ** module chunks = 0
 **/